import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/styles';
import { withFirebase } from '../Firebase';

import { authUserSelector } from '../Session/selectors';

import PopularUsersBase from './PopularUsers';
import { styles } from './PopularUsers.style';

const mapStateToProps = state => ({
  authUser: authUserSelector(state)
});

const mapDispatchToProps = dispatch => ({
  onSetAuthUser: authUser => dispatch({ type: 'AUTH_USER_SET', authUser }),
  showSighInDialog: (locationState, message) =>
    dispatch({ type: 'SIGN_IN_DIALOG_VISIBLE', locationState, message })
});

const PopularUsersPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFirebase
)(withStyles(styles)(PopularUsersBase));

export default PopularUsersPage;
